
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import StageBaseController from '../stage-base.controller';

export default class SabedoriaController extends StageBaseController {
    constructor($log, $state, $timeout, $interval, Dialog, Session) {
        'ngInject';
        super($log, $state, $timeout, $interval, Dialog, Session, 0);
        this.title="<span class='level'>Nível 1</span> <br/> Arraste para os espaços as figuras que completam a sequência";
    }

    $onInit(){
		this.lodash_version = _.VERSION;
        this.startGame();        
    }

    $onDestroy(){
        this.resetStage();
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/sabedoria/sabedoria.controller.js